import { Component, HostListener, inject } from '@angular/core';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { LevelModel } from 'src/app/models/supplier-score.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { NgClass } from '@angular/common';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { LevelModalComponent } from './level-modal/level-modal.component';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-level',
    templateUrl: './level.component.html',
    styleUrls: ['./level.component.scss'],
    imports: [IconMenuButtonComponent, MatMenu, MatMenuItem, NgClass, LevelModalComponent, MatButtonModule, MatIconModule, PageHeaderComponent, EmptyStateComponent]
})
export class LevelComponent {
  toastr = inject(ToastService);
  private readonly levelSvc = inject(SupplierService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);


  public levels: LevelModel[] = [];
  public showLevelModal: boolean = false;
  public selectedLevelToEdit?: LevelModel;

  ngOnInit() {
    this.getlevels();
  }

  getlevels() {
    this.levelSvc.getAllLevels().subscribe({
      next: (data) => {
        this.levels = data;
      },
    });
  }

  openModal(level?: LevelModel) {
    this.showLevelModal = true;
    this.selectedLevelToEdit = level;
  }

  @HostListener('window:keydown.escape', ['$event'])
  backToLevels(event?: KeyboardEvent) {
    this.showLevelModal = false;
  }

  deleteLevel(id: string) {
    this.swalFire
      .SwalFireQuestion(
        'Eliminar el nivel',
        '¿Está seguro que desea eliminar el nivel?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.levelSvc.deleteLevel(id, false).subscribe({
            next: (result) => {
              this.toastr.success(
                'Nivel eliminado',
                'El nivel se ha eliminado correctamente.'
              );
              this.getlevels();
            },
            error: (err) => {
              this.toastr.error('Error', 'No se pudo eliminar el nivel.');
            },
          });
        }
      });
  }

  enableDisableLevel(level: LevelModel) {
    level.isVisible = !level.isVisible;
    this.levelSvc
      .patchLevel(level.id, level)
      .subscribe({
        next: (result) => {
          this.toastr.success(
            'Nivel actualizado',
            'El nivel se ha actualizado correctamente.'
          );
          this.getlevels();
        },
        error: (err) => {
          this.toastr.error('Error', 'No se pudo actualizar el nivel.');
        },
      });
  }
}
